import { jsx, jsxs } from "react/jsx-runtime";
function NoPermission() {
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 120 120",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M56 29C56 27.3431 57.3431 26 59 26H108C109.657 26 111 27.3431 111 29V35H56V29Z",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M25 22C25 20.3431 26.3431 19 28 19H53.6903C54.8335 19 55.8774 19.6498 56.3821 20.6756L61.9008 31.8926C62.5737 33.2603 63.9656 34.1267 65.4899 34.1267H112C113.657 34.1267 115 35.4699 115 37.1267V91.75C115 93.4069 113.657 94.75 112 94.75H28C26.3431 94.75 25 93.4069 25 91.75V22Z",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M67 79.75H92.0905",
                stroke: "#AFB9C9",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M67 70.75H106.988",
                stroke: "#AFB9C9",
                strokeWidth: "3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("g", {
                filter: "url(#filter0_i_1362_739)",
                children: /*#__PURE__*/ jsx("path", {
                    d: "M5.6665 61.8532C5.56992 60.4146 6.51042 59.1108 7.90602 58.7485L30.6331 52.8491C31.3828 52.717 32.152 52.717 32.9017 52.8491L55.6273 58.7485C57.0229 59.1108 57.9634 60.4146 57.8668 61.8532L56.3862 83.9073C56.3862 92.4142 51.7343 100.32 44.0764 104.829L33.3976 111.116C32.9085 111.403 32.3434 111.556 31.7667 111.556C31.19 111.556 30.6249 111.403 30.1358 111.116L19.4569 104.829C11.799 100.32 7.14709 92.4142 7.14709 83.9073L5.6665 61.8532Z",
                    fill: "#D8DEEA"
                })
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M42.2316 75.3333H21.0454C19.3886 75.3333 18.0454 76.6764 18.0454 78.3332V91.6065C18.0454 93.2633 19.3886 94.6065 21.0454 94.6065H42.2316C43.8885 94.6065 45.2316 93.2633 45.2316 91.6065V78.3333C45.2316 76.6764 43.8885 75.3333 42.2316 75.3333Z",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M31.7896 88.2641C33.6874 88.2641 35.2258 86.7257 35.2258 84.828C35.2258 82.9303 33.6874 81.3918 31.7896 81.3918C29.8919 81.3918 28.3535 82.9303 28.3535 84.828C28.3535 86.7257 29.8919 88.2641 31.7896 88.2641Z",
                stroke: "#AFB9C9",
                strokeWidth: "3",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M39.5221 75.3336C39.5221 71.0887 35.9927 67.6475 31.64 67.6475C27.2874 67.6475 23.7534 71.0887 23.7534 75.3336",
                stroke: "#AFB9C9",
                strokeWidth: "3",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsxs("filter", {
                    id: "filter0_i_1362_739",
                    x: "5.65967",
                    y: "52.75",
                    width: "52.2139",
                    height: "58.8059",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ jsx("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ jsx("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ jsx("feOffset", {
                            dy: "4.70448"
                        }),
                        /*#__PURE__*/ jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "arithmetic",
                            k2: "-1",
                            k3: "1"
                        }),
                        /*#__PURE__*/ jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.686275 0 0 0 0 0.72549 0 0 0 0 0.788235 0 0 0 1 0"
                        }),
                        /*#__PURE__*/ jsx("feBlend", {
                            mode: "normal",
                            in2: "shape",
                            result: "effect1_innerShadow_1362_739"
                        })
                    ]
                })
            })
        ]
    });
}
export { NoPermission as default };
